/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Yogin's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Yogin Savani Portfolio",
    type: "website",
    url: "https://github.com/yoginsavani/portfolio.github.io",
  },
};

//Home Page
const greeting = {
  title: "Yogin Savani",
  logo_name: "YoginSavani",
  nickname: "M.tech Software System",
  subTitle:
    "Some things cannot be taught; they must be experienced. You never learn the most valuable lessons in life until you go through your own journey. - Roy T. Bennett",
  resumeLink:
    "https://drive.google.com/file/d/1FLvoXXpLsUzvLY-5Gopy1XVL6AZqsxG1/view?usp=sharing",
  portfolio_repository: "https://github.com/yoginsavani/portfolio.github.io",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/yoginsavani",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/yogin-savani-838913106/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://bit.ly/3vpfMrR",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:savaniyogin@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/yoginsavani",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/savaniyogin/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/tech1world_/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Embedded System",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Good level Knowledge of Embedded System in Automotive domain.",
        "⚡ Experience of AUTOSAR Each level, MCAL, BSW (OS, COM, Diagnostic, Memory, GPIO, CDD), RTE and Application development",
        "⚡ Having a Knowledge of Artificial Intelligence and Machine learning",
      ],
      softwareSkills:[],
    }, 
    {
      title: "Sharing Knowledge on youtube",
      fileName: "FullStackImg",
      skills: [
        "⚡ I'm Shring my Knowledge on my Youtube channel : Yogin Savani",
        "⚡ I've teached More than 1000 students (C, Python, Embedded System and data structure and algorithm)",
      ],
      softwareSkills: [],
    },

  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/savaniyogin",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@yogin2",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/yoginsavani",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "M.Tech. in Software System",
      subtitle: "BITS PILANI   WILP",
      logo_path: "bits_logo.png",
      alt_name: "BITS PILANI",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ I've learn till now. Data structure and algorithm, Distributed computing, DBMS and Embedded System design",
        "⚡ Apart from this I've learn Machine learning from Standford university. ",
        "⚡ Achievements:  Winner in Hackathon in machine learning (Hella)",
      ],
      website_link: "https://bits-pilani-wilp.ac.in/m-tech/software-systems.php",
    },
    {
      title: "B.tech in Electrical Engineering",
      subtitle: "Gujarat Technological University",
      logo_path: "Gujarat_Technological_University_Logo.png",
      alt_name: "GTU",
      duration: "2012 - 2016",
      descriptions: [
        "⚡ I have studied Electrical Power System, Power Electronics, Micro controller and Processors , etc.",
        "⚡ Achievements: 3 times winner in inter stat Robotics Event (Robo Death Race, Robo Blind maze solver)",
      ],
      website_link: "https://www.gtu.ac.in/",
    },
    {
      title: "Advance Course on Embedded Systems",
      subtitle: "Vector India Institute Bangalore",
      logo_path: "vector_logo.png",
      alt_name: "GTU",
      duration: "2016 - 2017",
      descriptions: [
        "⚡ Studied Embedded System, C, C++, TCP-IP, LINUX OS, 8051 and ARM Micro controller, I2c, SPI, Uart, CAN , LIN Protocol, IOT.",
      ],
      website_link: "http://www.vectorindia.org/",
    },
  ],

};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:"",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Soft skill development",
      subtitle: "- TCS Ion",
      logo_path: "TCS_logo.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1FzF3n95DrfgNlMImLYaPrX6SkCxj2McT/view",
      alt_name: "TCS ION",
      color_code: "#1F70C199",
    },
    {
      title: "Electrical Vehicles and Renewable Energy",
      subtitle: "- IIT Madras (Ashok Jhunjhunwala)",
      logo_path: "nptel_logo.png",
      certificate_link:
        "",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Training of Trainers",
      subtitle: "- IIT Roorkee (Santosh Rangnekar)",
      logo_path: "nptel_logo.png",
      certificate_link:
        "",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Complete Python Bootcamp",
      subtitle: "- Jose Portilla",
      logo_path: "udemy_logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-a0e2d2cf-286e-4867-9bfe-98a70f1ae635/",
      alt_name: "NPTEL",
      color_code: "#0C9D5899",
    },
    {
      title: "Python for Data Science and Machine learning",
      subtitle: "- Jose Portilla",
      logo_path: "udemy_logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-14b564a6-b1bb-4921-9de6-0999fec3947b/",
      alt_name: "NPTEL",
      color_code: "#0C9D5899",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work & Achievement",
  description:
    "I have worked on Embedded System in Automotive domain. worked on AUTOSAR 3 & 4. (All Stacks (MCAL, BSW, RTE, APplication) Having a good knowledge of CAR System and Software.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Senior Engineer",
          company: "Hella India Automotive Pvt ltd.",
          company_url: "https://www.hella.com/hella-in/index.html",
          logo_path: "hella_logo.png",
          duration: "January 2020 - PRESENT",
          location: "Pune, Maharashtra",
          description:
            "Responsible for Immobilizer Design & Development Complete Product. AUTOSAR, MCAL, BSW(CDD), RTE, Application and COM(CAN, LIN). having a good experience on vector tool chain (Davinci Configurator, Davinci Developer, Geny), IBM Doors, MKS PTC, Canoe, CAPL Script, VFlash Tool, Complete responsible for end to end customer delivery. Software integration. Customer : TATA ",
          color: "#0879bf",
        },
        {
          title: "Engineer",
          company: "Hella India Automotive Pvt ltd.",
          company_url: "https://www.hella.com/hella-in/index.html",
          logo_path: "hella_logo.png",
          duration: "September 2017 - Dec 2019",
          location: "Pune, Maharashtra",
          description:
            "Development and Porting of Production Mode Software:This Project involves the development of software which will be used in production of Body Control Module (BCM) ECU’s check and validate all the functionality of ECU. Responsible for Low level Driver development, •	Driver Development for ECU resources: System Basic Chip (SBC), High Side Driver (HSD) Handler, Low Side Driver (LSD) Handler, Relay Bridge Handler, Shift Register Handler, Multiplexer Handler, Motor Bridge and Simple Bridge, Configuration, Integration, Testing and Debugging of AUTOSAR COM stack- CAN, CAN FD and Lin. Customer: AUDI, BMW, Mercedes, JLR, Volkswagen.  ",
          color: "#9b1578",
        },
      ],
    },
    {
      title: "Achievements",
      experiences: [
        {
          title: "Winner in Hackathon on Machine learning",
          company: "Hella",
          company_url: "https://www.hella.com/hella-in/index.html",
          logo_path: "hella_logo.png",
          duration: "March 2021",
          location: "Pune, Maharashtra",
          description:
            "Hackathon on Machine learning. Automate calculate effort for acquisition Project",
          color: "#D83B01",
        },
        {
          title: "Pat on the Back Award",
          company: "Hella",
          company_url: "https://www.hella.com/hella-in/index.html",
          logo_path: "hella_logo.png",
          duration: "Dece 2018",
          location: "Pune, Maharashtra",
          description:
            "On time delivery, Taken complete owner ship of project, minimum bug fix report.",
          color: "#4285F4",
        },
        {
          title: "Winner in Robo Maze Solver",
          company: "ck pithawala college of engineering and technology, Surat",
          company_url: "https://ckpcet.ac.in/",
          logo_path: "Gujarat_Technological_University_Logo.png",
          duration: "April 2015",
          location: "Pune, Maharashtra",
          description:
            "Winner in Inter state Robotics Festival",
          color: "#4285F4",
        },
        {
          title: "Winner in Robo Maze Solver",
          company: "Mahatma Gandhi Institute of Technical Education & Research Centre, Navsari",
          company_url: "http://npvgiter.org/mgiter/",
          logo_path: "Gujarat_Technological_University_Logo.png",
          duration: "March 2015",
          location: "Pune, Maharashtra",
          description:
            "Winner in Inter state Robotics Festival",
          color: "#4285F4",
        },
        {
          title: "Runners up in Robo Maze Solver",
          company: "Mahatma Gandhi Institute of Technical Education & Research Centre, Navsari",
          company_url: "http://npvgiter.org/mgiter/",
          logo_path: "Gujarat_Technological_University_Logo.png",
          duration: "March 2015",
          location: "Pune, Maharashtra",
          description:
            "Runnersup in Inter state Robotics Festival",
          color: "#4285F4",
        },

      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  /*title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",*/
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "yogin_savani.jpeg",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you on Embedded System, ML, AI, Data structure and Algorithm, C, C++, Python and Soft skill development",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://www.tech1world.com/blog-1",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "A-404, Ojas Apartment, Baner-Pashan link Road, Pune-411021",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/oPfC2AcqbjxLB6XQ6",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 7567519898",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
